export const FormComponents: Record<string, React.ComponentType> = {};

export const registerFormComponent = (contentComponentName: string, component: React.ComponentType): void => {
  FormComponents[contentComponentName] = component;
};

export const getComponentFor = (contentComponentName: string): React.ComponentType => {
  return FormComponents[contentComponentName];
};
